import React from 'react';
import cn from 'classnames';
import * as uuid from 'uuid';
import InputBase, {InputBaseProps} from './InputBase';
import FormControl from '../FormControl';
import FormHelperText from '../FormHelperText';
import InputLabel from './InputLabel';

export interface OutlinedTextInputProps extends InputBaseProps {
  label?: React.ReactNode;
  labelClassName?: string;
  textHelper?: string;
  errorHelper?: string;
  required?: boolean;
  inputClassName?: string;
}

export const OutlinedTextInput = React.forwardRef(
  (
    {
  className,
  name,
  label,
  labelClassName,
  textHelper,
  errorHelper,
  inputClassName,
  size,
  ...props
    }: OutlinedTextInputProps,
    ref: React.Ref<HTMLInputElement>,
  ) => {
  const [id] = React.useState<string>(uuid.v4());
  const helperText = errorHelper?.trim() ? errorHelper : textHelper || errorHelper;

  return (
    <FormControl className={className} variant="outlined" size={size}>
        {label ? (
          <InputLabel className={labelClassName} htmlFor={id}>
            {label}
          </InputLabel>
        ) : null}
      <InputBase
        ref={ref}
        outlined={true}
        className={cn({'without-label': !label})}
        inputClassName={inputClassName}
        id={id}
        name={name}
        autoComplete={name}
        size={size}
        {...props}
        error={!!errorHelper?.trim()}
      >
        {props.children}
        <fieldset className="input-base__fieldset" />
      </InputBase>
        {textHelper || errorHelper ? <FormHelperText error={!!errorHelper?.trim()}>{helperText}</FormHelperText> : null}
    </FormControl>
  );
  },
);

OutlinedTextInput.displayName = 'OutlinedTextInput';

export default OutlinedTextInput;
